<template>
  <div class="issue">
    <div class="container">
      <h3>常见问题</h3>
      <div class="content">
        <div class="item" v-html="msgContent.msgContent">
          <!--<h5>怎么加入一线快递？</h5>-->
          <!--<p>-->
            <!--添加注册信息，注册登录后即可拥有一线快递账号，然后就去尽情的下订单吧。添加注册信息，注册登录后即可拥有一线快递账号，然后就去尽情的下订单吧。添加注册信息，注册登录后即可拥有一线快递账号，然后就去尽情的下订单吧。-->
          <!--</p>-->
        <!--</div>-->
        <!--<div class="item">-->
          <!--<h5>怎么加入一线快递？</h5>-->
          <!--<p>-->
            <!--添加注册信息，注册登录后即可拥有一线快递账号，然后就去尽情的下订单吧。添加注册信息，注册登录后即可拥有一线快递账号，然后就去尽情的下订单吧。添加注册信息，注册登录后即可拥有一线快递账号，然后就去尽情的下订单吧。-->
          <!--</p>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {reqFullText} from '../../api'
export default {
  data() {
    return {
      msgContent: ''
    }
  },
  created() {
    reqFullText('016').then(res => {
      console.log(res)
      if(res.code == 200) {
        this.msgContent = res.data.bussData
      }
    })
  }
}
</script>

<style scoped lang="less" type="text/less">
  .issue{
    padding-bottom: 60px;
    h3{
      padding:51px 0 41px;
      border-bottom: 1px solid #e1e1e1;
      font-size: 24px;
      font-weight: bold;
    }
    .content{
      .item{
        h5{
          margin-top:30px;
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: 600;
        }
        p{
          line-height: 30px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home/Issue.vue